import React from 'react'

export const TitleSectionNewWh = ({ title, className }) => {
  return (
    <div className={`titleSection_wrapper ${className}`}>{title}</div>
  )
}
